import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { MedicalAvailableInventorySchema, MedicalExpiredInventorySchema, MedicalExpiringInventorySchema, NonMedicalAvailableInventorySchema, NonMedicalExpiredInventorySchema, NonMedicalExpiringInventorySchema } from "./type";
import { pharmacyClient } from "@/connect";
import { InventoryLineItem, ItemType } from "@/gen/inventory/common_pb";
import { GetInventoryRequest, GetInventoryResponse } from "@/gen/inventory/get_inventory_pb";
import { GetMasterInventoryResponse } from "@/gen/inventory/get_master_inventory_pb";

export const getMedicalInventory = async (
    page: number,
    pageSize: number,
    search: string = '',
    filters?: {
        isAvailable?: boolean;
        isExpired?: boolean;
        expiringSoonDays?: number;
    }
): Promise<GetMasterInventoryResponse> => {
    return await pharmacyClient.getMasterInventory({
        page,
        pageSize,
        filter: {
            searchQuery: search,
            itemType: ItemType.MEDICAL,
            ...filters,
        }
    });
};

// Convenience wrappers for specific use cases
export const getAvailableMedicalInventory = async (
    page: number,
    pageSize: number,
    search: string = ''
): Promise<GetMasterInventoryResponse> => {
    return getMedicalInventory(page, pageSize, search, { isAvailable: true });
};

export const getAvailableMedicalInventoryExpiring = async (
    page: number,
    pageSize: number,
    search: string = ''
): Promise<GetMasterInventoryResponse> => {
    return getMedicalInventory(page, pageSize, search, { expiringSoonDays: 30 });
};

export const getAvailableMedicalInventoryExpired = async (
    page: number,
    pageSize: number,
    search: string = ''
): Promise<GetMasterInventoryResponse> => {
    return getMedicalInventory(page, pageSize, search, { isExpired: true });
};

export const getNonMedicalInventory = async (
    page: number,
    pageSize: number,
    search: string = '',
    filters?: {
        isAvailable?: boolean;
        isExpired?: boolean;
        expiringSoonDays?: number;
    }
): Promise<GetMasterInventoryResponse> => {
    return await pharmacyClient.getMasterInventory({
        page,
        pageSize,
        filter: {
            searchQuery: search,
            itemType: ItemType.NON_MEDICAL,
            ...filters,
        }
    });
};

export const getAvailableNonMedicalInventory = async (
    page: number,
    pageSize: number,
    search: string = ''
): Promise<GetMasterInventoryResponse> => {
    return getNonMedicalInventory(page, pageSize, search, { isAvailable: true });
};

export const getAvailableNonMedicalInventoryExpiring = async (
    page: number,
    pageSize: number,
    search: string = ''
): Promise<GetMasterInventoryResponse> => {
    return getNonMedicalInventory(page, pageSize, search, { expiringSoonDays: 30 });
};

export const getAvailableNonMedicalInventoryExpired = async (
    page: number,
    pageSize: number,
    search: string = ''
): Promise<GetMasterInventoryResponse> => {
    return getNonMedicalInventory(page, pageSize, search, { isExpired: true });
};
